import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=22082f40&"
import script from "./SelectLocale.vue?vue&type=script&lang=ts&"
export * from "./SelectLocale.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLocale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
